import { Injectable } from '@angular/core';

/**
 * Util Service
 * @preferred
 */
@Injectable({
  providedIn: 'root',
})
export class UtilService {
  /**
   * Scroll an element into the view
   * @param id The element to scroll into the view.
   */
  public scrollIntoView(id: string, accountForHeader?: boolean): void {
    if (accountForHeader) {
      document.getElementById(id).scrollIntoView();
      const globalNav = document.getElementsByTagName('global-nav');
      const loggedOutNav = document.getElementsByTagName('ten-logged-out-nav');
      const headerHeight = globalNav.length
        ? globalNav[0].children[0].clientHeight
        : loggedOutNav[0].children[0].clientHeight;

      const offset = window.scrollY - (headerHeight + 5);

      if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({ top: offset, behavior: 'smooth' });
      } else {
        window.scrollTo(0, offset);
      }
    } else {
      document.getElementById(id).scrollIntoView();
    }
  }

  /**
   * Loops object, stripping HTML from string properties
   * @param obj The object to strip HTML from
   */
  public stripHTMLFromObject(obj: object): void {
    Object.keys(obj).forEach((property) => {
      if (typeof obj[property] === 'string') {
        obj[property] = this.stripHTML(obj[property]);
      }
    });
  }

  /**
   * Strips HTML from a string
   * @param string The string to strip HTML from
   */
  public stripHTML(string: string): string {
    return string.replace(/(<([^>]+)>)/gi, '');
  }

  /**
   * Scroll to the top of the window
   */
  public scrollToTop(): void {
    window.scroll(0, 0);
  }

  public preloadImages(imageUrls: string[]): Promise<string[]> {
    const promises: Promise<string | null>[] = [];

    imageUrls.forEach((url: string) => {
      const promise = new Promise<string | null>((resolve) => {
        const image = new Image();
        image.src = url;

        image.onload = () => {
          resolve(url);
        };

        image.onerror = () => {
          resolve(null);
        };
      });

      promises.push(promise);
    });

    return Promise.all(promises).then((results) => results.filter((url) => url !== null));
  }
  /**
   * Finds an object in an array by a specified property and value.
   *
   * @param {T[]} array - The array to search in.
   * @param {string} property - The property to search for.
   * @param {string} value - The value to match against.
   * @return {T | undefined} The found object, or undefined if not found.
   */
  public findObjectByProperty<T>(array: T[], property: string, value: string): T | undefined {
    return array.find((object) => object[property] === value);
  }
}
